import React, { useEffect, useMemo, useState } from "react";
import { useAppDispatch } from "../../store/hooks";
import { useLoginSubmit } from "../../hooks/useLoginSubmit";
import {
  CleanLoginToken,
  disableFaceCheckSessionAutoStart
} from "../../actions/auth";
import { enrollLogout } from "../../services/enrollment";
import { LOCAL_STORAGE } from "../../constants/enums";

// ui components
import GetApp from "../../components/Common/GetApp";
import DynamicModal from "../../components/Common/DynamicModal";
import EnrollmentEntryModalBody from "../../components/Enrollment/EnrollmentEntryModalBody";
import AuthLayout from "../../components/Layouts/AuthLayout";
import LoginCard from "../../components/Login/LoginCard";
import EnrollCard from "../../components/Login/EnrollCard";

const Login = () => {
  const dispatch = useAppDispatch();

  const [storedUsername] = useState<string | null>(() =>
    localStorage.getItem(LOCAL_STORAGE.Username)
  );

  const [modalOpen, setModalOpen] = useState(false);
  const { onSubmit, errors } = useLoginSubmit();

  // clear auth token and previously fetched auth info in case back was clicked
  useEffect(() => {
    dispatch(CleanLoginToken());
    dispatch(disableFaceCheckSessionAutoStart());
    enrollLogout();
  }, [dispatch]);

  const initialValues = useMemo(
    () => ({ username: storedUsername ?? "", rememberMe: Boolean(storedUsername) }),
    [storedUsername]
  );

  return (
    <>
      <GetApp />
      <AuthLayout>
        <LoginCard
          onSubmit={onSubmit as never}
          errors={errors}
          initialValues={initialValues}
          initialRememberMe={Boolean(storedUsername)}
        />
        <EnrollCard onClick={() => setModalOpen(true)} />
      </AuthLayout>

      <DynamicModal
        className="max-w-325"
        showCloseIcon={false}
        open={modalOpen}
        setClose={() => setModalOpen(false)}
        body={<EnrollmentEntryModalBody setClose={() => setModalOpen(false)} />}
      />
    </>
  );
};

export default Login;